// extracted by mini-css-extract-plugin
export default {"textLink":"TextLink-module__textLink__ca1714aca96d706a819b"};